export default __webpack_public_path__ + "static/media/link4.57f31953.png";